{"Language":{"en":"Language","ja":"言語","ru":"Язык","es":"Idioma","fr":"Langue","pt":"Idioma","ar":"اللغة"}}